// -----------------------------------------------------------------------------
// Formular-Validierung (Profil)
// -----------------------------------------------------------------------------

const init = () => {
  // Nur auf Profil-Formular ausführen
  if ($('.js-body-profile-form').length <= 0) {
    return;
  }

  const $form = $('#formURLBasis');
  const type = $form.attr('data-type');
  const rolle = $form.attr('data-rolle');

  // Firmenbuchnummer nur bei Start-Ups und Corporates prüfen
  if (type === 'U' || (type === 'I' && rolle === 'C')) {
    validateFirmenbuch();
  }

  // Anzahl Frauen Feld nur bei Start-Ups anzeigen
  if (type === 'U' && $('.js-field-frauen').length > 0) {
    showAnzahlField();
  }

  validateWebsite();
  removeWhitespace();
  stripTags();
  validateVat();
  showMaxLength();

  initEventListeners();
};

const aIndicator = [
  'failure',
  'success',
  'waiting'
];

// Unternehmenssitz (IDs zum Glück auf allen Systemen gleich)
const aAustria = [78, 79, 80, 81, 82, 83, 84, 85, 86];

/**
 * Event-Listeners initialisieren
 */
const initEventListeners = () => {
  // Firmenbuchnummer: HTML5-Validierung triggern
  $('.js-field-firmenbuch').on('input', function () {
    document.forms.formURLBasis.elements.PEL_Firmenbuch.reportValidity();
  });
};

/**
 * Whitespace von Input-Feld entfernen
 */
const removeWhitespace = () => {
  $('input, textarea').on('focusout', (e) => {
    const $field = $(e.target);
    const valueTrimmed = $field.val().trim();
    $field.val(valueTrimmed);
  });
};

/**
 * HTML-Tags entfernen
 */
const stripTags = () => {
  $('input, textarea').on('focusout', (e) => {
    const $field = $(e.target);
    const valueProcessed = $field.val().replace(/(<([^>]+)>)/gi, '');
    $field.val(valueProcessed);
  });
};

/**
 * Hinweistext bei Hauptansprechpartner anzeigen, wenn keine Firmenbuchnummer vorhanden
 */
const validateFirmenbuch = () => {
  const $fieldFirmenbuch = $('.js-field-firmenbuch');
  const $fieldUnternehmenssitz = $('.js-field-unternehmenssitz');

  setVisibilityTextMainContact($fieldFirmenbuch);

  // Änderung von Firmenbuchnummer überwachen
  $fieldFirmenbuch.on('focusout', () => {
    setVisibilityTextMainContact();
  });

  // Änderung von Unternehmenssitz überwachen
  const observer = new MutationObserver(() => {
    setVisibilityTextMainContact();
  });
  observer.observe($fieldUnternehmenssitz[0], {
    attributes: true
  });
};

/**
 * Blendet Hinweistext bei Hauptansprechpartner ein bzw. aus
 */
const setVisibilityTextMainContact = () => {
  const $fieldFirmenbuch = $('.js-field-firmenbuch');
  const $fieldUnternehmenssitz = $('.js-field-unternehmenssitz');
  const valueFirmenbuch = $fieldFirmenbuch.val();
  const valueUnternehmenssitz = $fieldUnternehmenssitz.children('option:selected').val();

  // Weder Firmenbuchnummer noch Unternehmenssitz angegeben -> Text zeigen
  if (valueFirmenbuch === '' && valueUnternehmenssitz === '') {
    $('.js-validation-text-firmenbuch').show();
    return;
  }

  // Unternehmenssitz im Ausland -> Text verstecken
  const idUnternehmenssitz = parseInt(valueUnternehmenssitz, 10);
  if (aAustria.includes(idUnternehmenssitz) === false) {
    $('.js-validation-text-firmenbuch').hide();
    return;
  }

  // Text abhängig von Feld "Firmenbuchnummer" zeigen/verstecken
  if (valueFirmenbuch === '') {
    $('.js-validation-text-firmenbuch').show();
  } else {
    $('.js-validation-text-firmenbuch').hide();
  }
};

/**
 * Website Eingabe auf HTTPS prüfen und ggf. erweitern
 */
const validateWebsite = () => {
  $('.js-profile-website').on('change keydown paste input', function (e) {
    const urlPattern = new RegExp(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/);
    let inputValue = e.target.value;

    if (urlPattern.test(inputValue)) {
      // clear http && https from inputValue
      inputValue = inputValue.replace('https://', '').replace('http://', '');

      // add https to inputValue
      inputValue = `https://${inputValue}`;
    }
    $(this).val(inputValue);
  });
};

/**
 * Formular-Validierungen definieren
 */
const validateVat = () => {
  const $fieldVat = $('.js-validate-vat');

  if (!$fieldVat.length) {
    return;
  }

  executeRequest(false);

  $fieldVat.on('focusout', (e) => {
    e.preventDefault();
    executeRequest(true);
  });
};

/**
 *
 * @returns {boolean}
 */
const checkAndProcessValue = () => {
  const $fieldVat = $('.js-validate-vat');

  // Wert aus Formular holen
  let vat = $fieldVat.val();

  // Whitespace entfernen
  vat = vat.replace(/\s/g, '');
  $fieldVat.val(vat);

  // Validierung nur bei vorhandener VAT ausführen
  if (vat === '') {
    return false;
  }

  // Alle Buchstaben auf Großbuchstaben ändern
  vat = vat.toUpperCase();
  $fieldVat.val(vat);

  // Bestandteile der Eingabe prüfen
  const re = /([A-Z]{2})(\w+)/;
  const aMatch = vat.match(re);
  if (aMatch && (1 in aMatch && 2 in aMatch) === false) {
    return false;
  }

  return true;
};

/**
 * AJAX-Request durchführen
 *
 * @param isInitialRequest
 */
const executeRequest = (isInitialRequest) => {
  if (checkAndProcessValue() === false) {
    resetIndicator();
    hideText();
    return;
  }

  const vat = $('.js-validate-vat').val();

  // Debug-Modus aktivieren
  let debug = '';
  if (vat === 'ZZ999888777') {
    debug = '&debug=error';
  }

  resetIndicator();
  showIndicator('waiting');

  $.ajax({
    method: 'GET',
    url: `profile/validateVat?${Date.now()}${debug}`,
    data: { vat }
  })
    .done(function (dataStr) {
      const data = JSON.parse(dataStr);

      // If: erfolgreich validiert
      // Else if 1: fehlerhaft validiert
      // Else if 2: API nicht erreichbar
      if (data.isValid === true) {
        showIndicator('success');
        showText('success');

        // Tag entfernen (falls vorhanden), wenn es sich nicht um Request bei onload handelt
        if (isInitialRequest) {
          tagUser('remove');
        }
      } else if (data.isValid === false) {
        showIndicator('failure');
        showText('failure');

        // Tag entfernen (falls vorhanden), wenn es sich nicht um Request bei onload handelt
        if (isInitialRequest) {
          tagUser('remove');
        }
      } else if (data.isError === true) {
        showText('failure');
        showIndicator('failure');

        // User taggen, wenn es sich nicht um Request bei onload handelt
        if (isInitialRequest) {
          tagUser('add');
        }
      }
    })
    .fail(function () {
      resetIndicator();
    });
};

/**
 * Alle CSS-Klassen für Icon zurücksetzen
 */
const resetIndicator = () => {
  for (const indicator of aIndicator) {
    $('.js-validate-vat-indicator').removeClass(`form__validation--${indicator}`);
  }
};

/**
 * CSS-Klasse für Icon setzen
 *
 * @param type
 */
const showIndicator = (type) => {
  resetIndicator();
  $('.js-validate-vat-indicator').addClass(`form__validation--${type}`);
};

/**
 * Hinweistext ein- bzw. ausblenden
 *
 * @param type
 */
const showText = (type) => {
  hideText();
  $(`.js-validate-vat-text-${type}`).fadeIn();
};

/**
 * Hinweistext ein- bzw. ausblenden
 */
const hideText = () => {
  $('.js-validate-vat-text-success').hide();
  $('.js-validate-vat-text-failure').hide();
};

/**
 * User taggen
 *
 * @param cmd
 */
const tagUser = (cmd) => {
  const token = $('.js-validate-vat').attr('data-token');
  $.post(`user/tag/${cmd}`, {token});
};

/**
 * Maximal verfügbare Zeichen anzeigen
 */
const showMaxLength = () => {
  // Initial anzeigen
  $('input[maxlength], textarea[maxlength]').each(function () {
    updateMaxLength($(this));
  });

  // Bei Key-Event aktualisieren
  $('input[maxlength], textarea[maxlength]').on('input', function () {
    updateMaxLength($(this));
  });
};

/**
 * Noch verfügbare Zeichen aktualisieren
 *
 * @param $element
 */
const updateMaxLength = ($element) => {
  const current = $element.val().length;
  const max = $element.attr('maxlength');

  $element.next('.js-maxlength').remove();
  $element.after(`<small class="js-maxlength">${current}/${max}</small>`);
};


/**
 * Zeit Anzahl Frauen Feld für Startups an, falls "Ja" für Frauen Dropdown gewählt ist
 */
const showAnzahlField = () => {
  var fieldFrauen = $('.js-field-frauen');
  var fieldFrauenAnzahl = $('.js-field-frauen-anzahl');
  if (fieldFrauen.val() === '155') {
    fieldFrauenAnzahl.removeClass('d-none');
  }

  fieldFrauen.change(function () {
    var selected = $(this).val();
    if (selected === '155') {
      fieldFrauenAnzahl.removeClass('d-none');
    } else {
      fieldFrauenAnzahl.addClass('d-none');
      $('.js-field-frauen-anzahl input').val('');
    }
  });
};

export {
  init
};
